import React from 'react';
import PropTypes from 'prop-types';

const DeleteButton = ({ modelId, deleteFunction, ...rest }) => {
	const handleDelete = () => {
		// Confirm before deleting
		if (window.confirm('Are you sure you want to delete this item?')) {
			deleteFunction(modelId);
		}
	};

	return (
		<button
			onClick={handleDelete}
			{...rest}
		>
			Delete
		</button>
	);
};

// Define prop types for better validation
DeleteButton.propTypes = {
	modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	deleteFunction: PropTypes.func.isRequired,
};

export default DeleteButton;
